"use strict";

const wishlistDiv = document.querySelector(".wishlist-page-main");

var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }

      this.preventRemoveRedirect();
    },

    getWishlistItems: function () {
      try {
        return JSON.parse(localStorage.getItem("glozin__wishlist-items")) || [];
      } catch (e) {
        return [];
      }
    },

    setWishlistItems: function (items) {
      localStorage.setItem("glozin__wishlist-items", JSON.stringify(items));
    },

    init: function () {
      const _this = this;
      const wishlist_items = _this.getWishlistItems();

      if (wishlistDiv) {
        const div_no_product = wishlistDiv.querySelector(
          ".wishlist-no-product-js"
        );

        if (wishlist_items === null || wishlist_items.length === 0) {
          _this.skeletonFunction(0);
          if (div_no_product) div_no_product.classList.remove("hidden");
        } else {
          var query = "";

          wishlist_items.forEach((e, key, wishlist_items) => {
            if (!Object.is(wishlist_items.length - 1, key)) {
              query += e + "%20OR%20id:";
            } else {
              query += e;
            }
          });

          const section = document.querySelector(".wishlist-page-section");
          if (!section) return;

          const section_id = section.dataset.sectionId;

          var productAjaxURL =
            "?section_id=" +
            section_id +
            "&type=product&options[unavailable_products]=last&q=id:" +
            query;

          fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = parser.parseFromString(responseText, "text/html");

              const exist_row = wishlistDiv.querySelector(
                ".wishlist-list-items"
              );

              if (exist_row) {
                exist_row.remove();
              }

              const er = html.querySelector(
                ".wishlist-page-main .wishlist-list-items"
              );

              if (wishlist_items.length !== 0 && er) {
                wishlistDiv.innerHTML = html.querySelector(
                  ".wishlist-page-main"
                ).innerHTML;

                _this.skeletonFunction(700);
              } else {
                _this.skeletonFunction(0);
                if (div_no_product) div_no_product.classList.remove("hidden");
              }

              _this.mergeItems();
              _this.preventRemoveRedirect();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (typeof initLazyloadItem === "function") {
                initLazyloadItem();
              }
            });
        }
      }
    },

    preventRemoveRedirect: function () {
      if (!wishlistDiv) return;

      document.addEventListener(
        "click",
        function (event) {
          const wishlistBtn = event.target.closest("button-wishlist");

          if (!wishlistBtn) return;

          const wishlistPage = event.target.closest(".wishlist-page-section");
          if (!wishlistPage) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const productId = wishlistBtn.dataset.productId;
          const productCard = wishlistBtn.closest(".wishlist-list");

          let items = WishlistPageShopify.getWishlistItems();

          if (productId) {
            items = items.filter((item) => String(item) !== String(productId));
            WishlistPageShopify.setWishlistItems(items);
          }

          if (productCard) {
            productCard.remove();
          }

          const remainingProducts = wishlistDiv.querySelectorAll(".wishlist-list");

          if (remainingProducts.length === 0) {
            const listWrapper = wishlistDiv.querySelector(".wishlist-list-items");
            const emptyBox = wishlistDiv.querySelector(".wishlist-no-product-js");

            if (listWrapper) listWrapper.remove();
            if (emptyBox) emptyBox.classList.remove("hidden");
          }

          return false;
        },
        true
      );
    },

    mergeItems: function () {
      const arr = [];

      if (wishlistDiv) {
        wishlistDiv
          .querySelectorAll(".product-item__action button-wishlist")
          .forEach((e) => {
            if (e?.dataset.productId) {
              arr.push(e.dataset.productId);
            }
          });
      }

      localStorage.setItem("glozin__wishlist-items", JSON.stringify(arr));
    },

    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        if (document.querySelector("skeleton-page")) {
          document.querySelector("skeleton-page").remove();
        }

        if (document.querySelector(".wishlist-page-section-inner")) {
          document
            .querySelector(".wishlist-page-section-inner")
            .classList.remove("hidden");
        }
      }, timer);
    },
  };
})();

WishlistPageShopify.initWishlistItems();